import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './globals.css';
import { App } from './app';
import { AuthProvider } from './auth/AuthProvider';
import { WorkspaceGate } from './components/workspace/workspace-gate';
import { GuestLanding } from './guest/guest-landing';
import { guestCodeFromUrl } from './guest/guest-session';
import { UnifiedJoin } from './join/unified-join';
import { unifiedJoinCodeFromUrl } from './join/pending-join';
import { queryClient } from './queries/query-client';

// A scanned unit-invite QR (?join=…) shows the one-code landing (member or
// guest) pre-login; a mission QR (/join?code=…) enters guest mode directly.
// Both bypass the Keycloak-gated app until the visitor chooses.
const guestCode = guestCodeFromUrl();
const inviteCode = unifiedJoinCodeFromUrl();

createRoot(document.getElementById('root')!).render(
  inviteCode ? (
    <UnifiedJoin code={inviteCode} />
  ) : guestCode ? (
    <GuestLanding joinCode={guestCode} />
  ) : (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <WorkspaceGate>
          <App />
        </WorkspaceGate>
      </QueryClientProvider>
    </AuthProvider>
  ),
);
